const ENV = import.meta.env.MODE;

const ENV_ENUM = {
  alpha: 'alpha',
  delta: 'delta',
  staging: 'staging',
  customer: 'customer',
};

const LOCAL_PORTAL_ORIGIN = 'http://localhost:3001';

const LOCAL_PORTAL_URL = `${LOCAL_PORTAL_ORIGIN}/`;

const GRAPHQL_URL =
  ENV === ENV_ENUM.alpha
    ? 'https://admin-backend.alpha.bioflux.io'
    : ENV === ENV_ENUM.delta
      ? 'https://admin-backend.delta.bioflux.io'
      : ENV === ENV_ENUM.staging
        ? 'https://admin-backend.staging.biotricity.com'
        : 'https://admin-backend.customer.biotricity.com';

const SOCKET =
  ENV === ENV_ENUM.alpha
    ? 'https://sio.alpha.bioflux.io'
    : ENV === ENV_ENUM.delta
      ? 'https://sio.delta.bioflux.io'
      : ENV === ENV_ENUM.staging
        ? 'https://sio.staging.biotricity.com'
        : 'https://sio.customer.biotricity.com';

const SOCKET_STREAMING_URL =
  ENV === ENV_ENUM.alpha
    ? 'wss://cprc0ghzv8.execute-api.us-east-2.amazonaws.com/alpha'
    : ENV === ENV_ENUM.delta
      ? 'wss://o7rz0eanr5.execute-api.us-east-2.amazonaws.com/delta'
      : ENV === ENV_ENUM.staging
        ? 'wss://ecgstreaming.staging.biotricity.com'
        : 'wss://ecgstreaming.customer.biotricity.com';

const SHIPPO_LABEL_URL =
  ENV === ENV_ENUM.alpha
    ? 'https://sm.alpha.bioflux.io/shippo/label/'
    : ENV === ENV_ENUM.delta
      ? 'https://sm.delta.bioflux.io/shippo/label/'
      : ENV === ENV_ENUM.staging
        ? 'https://sm.staging.biotricity.com/shippo/label/'
        : 'https://sm.customer.biotricity.com/shippo/label/';

const ENV_DOMAIN =
  ENV === ENV_ENUM.alpha || ENV === ENV_ENUM.delta ? '.bioflux.io' : '.biotricity.com';

const USER_VERIFICATION_RELEASE_DATE =
  ENV === ENV_ENUM.alpha
    ? '01/17/2024'
    : ENV === ENV_ENUM.delta
      ? '01/23/2024'
      : ENV === ENV_ENUM.staging
        ? '01/26/2024'
        : '02/05/2024';

const ERP_PORTAL_ORIGIN =
  ENV === ENV_ENUM.alpha
    ? 'https://erp.alpha.bioflux.io'
    : ENV === ENV_ENUM.delta
      ? 'https://erp.delta.bioflux.io'
      : ENV === ENV_ENUM.staging
        ? 'https://erp.staging.biotricity.com'
        : 'https://erp.customer.biotricity.com';

const URL_ERP_PORTAL =
  window.location.hostname === 'localhost' ? LOCAL_PORTAL_ORIGIN : ERP_PORTAL_ORIGIN;

const LINK_REDIRECT_AWS = `${ERP_PORTAL_ORIGIN}/login/`;

const LINK_REDIRECT_AWS_BIOCARE_PORTAL =
  ENV === ENV_ENUM.alpha
    ? 'https://alpha.bioflux.io/'
    : ENV === ENV_ENUM.delta
      ? 'https://delta.bioflux.io/'
      : ENV === ENV_ENUM.staging
        ? 'https://staging.biotricity.com/'
        : 'https://customer.biotricity.com/';

const LINK_REDIRECT_AWS_CARDIO_ONE_PORTAL =
  ENV === ENV_ENUM.alpha
    ? 'https://alpha.bioflux.io/'
    : ENV === ENV_ENUM.delta
      ? 'https://delta.bioflux.io/'
      : ENV === ENV_ENUM.staging
        ? 'https://webapp.nqa.rhythm.cardioone.com/logout'
        : 'https://rhythm.cardioone.com/logout';

const MERCY_PORTAL_URL =
  ENV === ENV_ENUM.alpha
    ? 'https://mercy.alpha.bioflux.io/'
    : ENV === ENV_ENUM.delta
      ? 'https://mercy.delta.bioflux.io/'
      : ENV === ENV_ENUM.staging
        ? 'https://mercy.staging.biotricity.com/'
        : 'https://mercy.customer.biotricity.com/';

const BIOCARE_PORTAL_MERCY_URL =
  window.location.hostname === 'localhost' ? LOCAL_PORTAL_URL : MERCY_PORTAL_URL;

const BIOCARE_PORTAL_URL =
  window.location.hostname === 'localhost' ? LOCAL_PORTAL_URL : LINK_REDIRECT_AWS_BIOCARE_PORTAL;

const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

const GTM_KEY = import.meta.env.VITE_GTM_KEY;

export {
  ENV,
  ENV_ENUM,
  GRAPHQL_URL,
  SOCKET,
  SOCKET_STREAMING_URL,
  SHIPPO_LABEL_URL,
  ENV_DOMAIN,
  USER_VERIFICATION_RELEASE_DATE,
  LINK_REDIRECT_AWS,
  LINK_REDIRECT_AWS_BIOCARE_PORTAL,
  BIOCARE_PORTAL_MERCY_URL,
  BIOCARE_PORTAL_URL,
  GOOGLE_API_KEY,
  GTM_KEY,
  LINK_REDIRECT_AWS_CARDIO_ONE_PORTAL,
  LOCAL_PORTAL_URL,
  ERP_PORTAL_ORIGIN,
  URL_ERP_PORTAL,
  MERCY_PORTAL_URL,
};
